var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thanks"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$ml.get('Thank you for purchase!')))]),_c('button',{staticClass:"next h-empty-btn",on:{"click":_vm.next}},[_vm._v(" Continue ")])])}
var staticRenderFns = []

export { render, staticRenderFns }